import { apiService } from '@/services/APIService';

export default {
  takeQuestion(params) {
    apiService.post('/transfers/take', params);
  },
};
